// libraries
import jsPDF from 'jspdf';
import moment from 'moment';

// vuex
import { mapGetters } from 'vuex';

// font
import font from '../assets/fonts/PTSans';

export default {
  data() {
    return {
      dynamicCanvasSelector: '.dynamic-chart canvas',
      tonalityCanvasSelector: '.tonality-chart canvas',
      canvasDynamicImg: null,
      canvasTonalityImg: null,
      period: 'За сегодня',
      format: 'HH:mm DD.MM.YYYY',
    };
  },
  computed: {
    ...mapGetters([
      'threadName',
    ]),
  },
  methods: {
    getPeriod(period) {
      this.period = period;
    },
    printReportDocument() {
      const canvasDynamic = this.findReportCanvas(this.dynamicCanvasSelector);
      const canvasTonality = this.findReportCanvas(this.tonalityCanvasSelector);

      this.canvasDynamicImg = canvasDynamic.toDataURL();
      this.canvasTonalityImg = canvasTonality.toDataURL();

      this.printReport();
    },
    findReportCanvas(selector) {
      const printing = document.querySelector('#printing');
      return printing.querySelector(selector);
    },
    setReportDateTime() {
      return moment().format(this.format);
    },
    setPeriod() {
      return `на ${moment().format('HH:mm DD.MM.YYYY')}`;
    },
    printReport() {
      const doc = new jsPDF();
      doc.addFileToVFS('PTSans.ttf', font.PTSans);
      doc.addFont('PTSans.ttf', 'PTSans', 'normal');
      doc.setFont('PTSans');
      doc.setFontSize(16);
      doc.text(15, 15, `Динамика постов по сетям ${this.threadName} ${this.setPeriod()}`);
      doc.addImage(this.canvasDynamicImg, 'JPEG', 10, 25, 190, 85);
      doc.text(15, 120, `Динамика тональности ${this.threadName} ${this.setPeriod()}`);
      doc.addImage(this.canvasTonalityImg, 'JPEG', 10, 130, 190, 40);
      doc.save(`График ${this.threadName} ${this.setPeriod()} ${this.setReportDateTime()}.pdf`);
    },
  },
};
